var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sections" }, [
    _c(
      "section",
      [
        _c("h3", [_vm._v("Monatsgehalt auf Basis Vollzeit")]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Bandbreite je nach Erfahrung / Ausbildung / Kompetenz")
        ]),
        _vm._v(" "),
        _c("SalaryEdit", {
          staticClass: "mt-2",
          attrs: { range: "", "with-calculator-link": "" },
          on: { input: _vm.emitChangeEvent },
          model: {
            value: _vm.salary,
            callback: function($$v) {
              _vm.salary = $$v
            },
            expression: "salary"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("h3", [_vm._v("Mindestgehalt")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n\t\t\tWichtig: In bestimmten Ländern (z.B. Österreich) muss laut Gesetz das Mindestgehalt eines Jobs angegeben\n\t\t\twerden, unabhängig davon, ob das tatsächlich bezahlte Gehalt darüber liegt.\n\t\t"
          )
        ]),
        _vm._v(" "),
        _c("SalaryEdit", {
          staticClass: "mt-2",
          attrs: { "for-collective": "", "with-calculator-link": false },
          on: { input: _vm.emitChangeEvent },
          model: {
            value: _vm.salaryCollective,
            callback: function($$v) {
              _vm.salaryCollective = $$v
            },
            expression: "salaryCollective"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }